import { makeStyles } from 'tss-react/mui';

const BasicCaseInfo = makeStyles()((theme) => {
    return {
        container: {
            borderRadius: 4,
            padding: 10,
        },
    };
});

export default BasicCaseInfo;
